import {
  ExportButton,
  FilterLiveSearch,
  FunctionField,
  List,
  RaRecord,
  ShowButton,
  TextField,
  TopToolbar,
  useRecordContext,
  useListContext,
} from "react-admin";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import ResourceSelectDialogButton from "../Common/ResourceSelectDialogButton";
import { Box, Card, CardContent, InputLabel, Button, Link } from "@mui/material";
import { FilterAlt, FilterAltOff } from "@mui/icons-material";
import { setCookSideFilter } from "../../store/reducers/customSelect";
import { SelectColumnsButton } from "../Common/ReactAdminWrapper/SelectColumnsButton";
import { DatagridConfigurable } from "../Common/ReactAdminWrapper/DatagridConfigurable";
import CallButton from "../Common/CallButton/CallButton";
import { UserType } from "../../enums/common";
import CookCreate from "./CookCreate";
import { FreshLeadStatus } from "../../enums/FreshLeadStatus";
import { AllCookOnBoardingSubStatus } from "../../enums/AllCookOnboardingSubStatus";
import CooksProfileLink from "../Common/CooksProfileLink";
import { CookWorkStatus } from "../../enums/CookWorkStatus";
import { CookWorkStatusReasoning } from "../../enums/CookWorkStatusReasoning";
import React, { useEffect, useState } from "react";
import FilterListIcon from '@mui/icons-material/FilterList';
import AdvancedCookFilterDialog from "./AdvancedCookFilterDialog";
import { NewLeadCategoryEnum } from "../../enums/CookCategoryEnum";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import { NewVendorSource } from "../../enums/NewVendorSource";
import CityService from "../../services/CityService";
import HubServices from "../../services/HubServices";
import RosterService from "../../services/RosterService";
import { formatDate } from "../../utils/DateTimeUtils";
import { CookServiceTypeEnum, CookServiceTypeLabels } from "../../enums/CookServiceTypeEnum";
import { CookTypeFilter } from "../../enums/CookTypeFilterEnum";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper from "../Common/StyledDatagridWrapper";

const cityService = new CityService();
const hubService = new HubServices();
const rosterService=new RosterService();

const CustomRefrenceField = (props: { source: string, label: string, reference: string }) => {
  const record = useRecordContext();
  if (!record.cookFullProfile) return <></>;
  return (
    <Link href={`/#/${props.reference}/${record?.cookFullProfile[props.source]}/show`}>{record?.cookFullProfile[props.source]}</Link>
  )
}

const FilterSidebar = () => {
  return (
    <Box
      sx={{
        marginTop: "65px",
        display: {
          xs: "none",
          sm: "block",
        },
        order: -1,
        width: "20em",
        marginRight: "1em",
      }}
    >
      <Card>
        <CardContent>
          <InputLabel>Gender(Male/Female)</InputLabel>
          <FilterLiveSearch source="gender" />
        </CardContent>
      </Card>
    </Box>
  );
};

const ListActions = (props: any) => {
  const dispatch = useAppDispatch();
  const { setFilters } = useListContext();
  const resetFilter = () => {
    setFilters({}, [], false);
    props?.setFilter([]);
  };

  return (
    <TopToolbar>
      <Button
        variant="text"
        size={"small"}
        onClick={resetFilter}
        startIcon={<FilterListOffIcon />}
      >
        {'Clear Filters'}
      </Button>
      <Button
        variant="text"
        size={"small"}
        onClick={() => {
          props?.setOpenAdvancedFilter(true);
        }}
        startIcon={<FilterListIcon />}
        color="primary"
      >
        {'Advanced filter'}
      </Button>
      <SelectColumnsButton callback={() => { }} />
      <Button variant="text"
        size={"small"}
        onClick={() => {
          dispatch(
            setCookSideFilter({
              cookSideFilter: !props.openSideFilterShow,
            })
          );
        }}
        startIcon={props.openSideFilterShow ? <FilterAlt /> : <FilterAltOff />} color="primary"
      >
        Filter
      </Button>
      <ExportButton />
      <CookCreate />
    </TopToolbar>
  );
};

const Cooks = (props: any) => {
  const isCustomSelectOpen = useAppSelector(
    (state) => state?.customSelect?.value.open
  );
  const showSideFilter = useAppSelector(
    (state) => state.customSelect.value.cookSideFilter
  );

  const [openAdvancedFilter, setOpenAdvancedFilter] = useState<boolean>(false);

  const [allCities, setAllCities] = useState<any>([]);

  const [choices, setChoices] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [filter,setFilter] = useState<any>([]);
  const[owners,setOwners]=useState<any>([])

  const fetchOptions = async () => {
    setLoading(true);
    hubService.getAllHubs(130, 0, {}, {}, {}).then((result:any) => {
      setChoices(result.data);
      setLoading(false);
    })
  };

    useEffect(() => {
        rosterService
          .getAllEmployeesForRoster("COOK_PROFILE_LEADS")
          .then((res) => {
            setOwners(res);
          })
         fetchOptions(); 
    }, [])


  const cityOptions = allCities
    ? allCities.map((eachCity: any) => ({
        value: eachCity?.name,
        label: eachCity?.name,
      }))
    : [];

  const filterFields: CommonFilterField[] = [
    { type: "text", label: "First Name", source: "firstName" },
    { type: "text", label: "Last Name", source: "lastName" },
    { type: "text", label: "Phone Number", source: "mobile" },
    { type: "text", label: "Cook Id", source: "cookId" },
    {
      type: "multiselect",
      label: "Preff. Working Cities",
      source: "preferredCities",
      options: cityOptions,
    },
    {
      type: "select",
      label: "Current City",
      source: "currentAddressCity",
      options: cityOptions,
    },
    {
      type: "multiselect",
      label: "Onboarding Status",
      source: "onboardingStatus",
      options: Object.values(FreshLeadStatus).map((key) => ({
        value: key,
        label: key,
      })),
    },
    {
      type: "select",
      label: "Cook Type",
      source: "isMgCook",
      options: [
        { value: CookTypeFilter.MG_COOK, label: "MG_COOK" },
        { value: CookTypeFilter.PART_TIME, label: "PART_TIME" },
        { value: CookTypeFilter.ACTIVE_PART_TIME, label: "ACTIVE_PART_TIME" },
      ],
    },
    {
      // Replaces the old "MG Tag" filter — those values are part of Cook Type List now.
      // Sent as a top-level any-of param, not through the generic filter builder: cookTypeList
      // is a JSON column and ConstructSequelizeFilters would emit an invalid IN against it.
      type: "multiselect",
      label: "Cook Type List",
      source: "cookTypeList",
      options: Object.values(CookServiceTypeEnum).map((key) => ({
        value: key,
        label: CookServiceTypeLabels[key],
      })),
    },
    {
      type: "multiselect",
      label: "Onboarding SubStatus",
      source: "onboardingSubStatus",
      minWidth: 220,
      options: Object.values(AllCookOnBoardingSubStatus).map((key) => ({
        value: key,
        label: key,
      })),
    },
    {
      type: "multiselect",
      label: "Work Status",
      source: "workStatus",
      options: Object.values(CookWorkStatus).map((key) => ({
        value: key,
        label: key,
      })),
    },
    {
      type: "multiselect",
      label: "Work Status Reasoning",
      source: "cookWorkStatusReasoning",
      minWidth: 220,
      options: Object.values(CookWorkStatusReasoning).map((key) => ({
        value: key,
        label: key,
      })),
    },
    {
      type: "multiselect",
      label: "Category",
      source: "cookCategory",
      options: Object.values(NewLeadCategoryEnum).map((key) => ({
        value: key,
        label: key,
      })),
    },
    {
      type: "multiselect",
      label: "Source",
      source: "source",
      options: Object.values(NewVendorSource).map((key) => ({
        value: key,
        label: key,
      })),
    },
    {
      type: "select",
      label: "Chef Hub Name",
      source: "chefHub",
      options: !loading
        ? choices.map((hub: any) => ({
            value: hub?.id,
            label: hub?.name,
          }))
        : [],
    },
    { type: "text", label: "Sub Source", source: "subSource" },
    { type: "text", label: "Owner", source: "ownerEmail" },
    {
      type: "select",
      label: "Owner Name",
      source: "ownerEmail",
      options: owners
        ? [
            ...owners.map((owner: any) => ({
              value: owner?.adminDetails?.email,
              label: owner?.adminDetails?.name,
            })),
            { value: "none", label: "NONE" },
          ]
        : [],
    },
    { type: "text", label: "Chef Hub Id", source: "chefHub" },
    { type: "date", label: "From Created At Date", source: "startDates", minWidth: 200 },
    { type: "date", label: "To Created At Date", source: "endDates", minWidth: 200 },
  ];

  useEffect(() => {
    cityService.fetchAllCities(100, 0, {isCurrentlyServing:"YES"}, {}).then((res) => {
      setAllCities(res?.data || []);
    });
  }, []);

  return (
    <>
      <List
        {...props}
        className="toolbar-custom-css"
        actions={<ListActions openSideFilterShow={showSideFilter} setOpenAdvancedFilter={setOpenAdvancedFilter} setFilter={setFilter}/>}
        aside={showSideFilter ? <FilterSidebar /> : null}
        sx={{
          "& .RaList-content": {
            boxShadow: "none",
            backgroundColor: "transparent",
          },
        }}
      >
        <>
        <CommonFilterCard fields={filterFields} columns={6} />

        <br />

        {/* SOS-style card shell; the datagrid inside keeps its original styling */}
        <StyledDatagridWrapper title="Cooks">
        <DatagridConfigurable bulkActionButtons={false}>
          {/*Will be active if custom popup is open*/}
          {!isCustomSelectOpen ? [<ShowButton key={"6"} label="Show" />]:[<ResourceSelectDialogButton />]}
          <TextField label="Cook Id" source="cookFullProfile.cookId" sortable={false} />
          <TextField label="First Name" source="cookFullProfile.firstName" sortable={false} />
          <TextField label="Last Name" source="cookFullProfile.lastName" sortable={false} />
          <FunctionField
            label="Mobile"
            render={(record: any) => (
              <CallButton
                toPhoneNumber={record?.mobile}
                userType={UserType.COOK}
                referenceId={record?.cookFullProfile?.cookId}
                referenceModelName="COOK_FULL_PROFILE"
              />
            )}
          />
          <FunctionField
            label="Address"
            render={(record: any) => (
              <Box minWidth={200}>{record?.cookFullProfile?.permanentAddressLine1}</Box>
            )}
          />
          <TextField label="Gender" source="cookFullProfile.gender" sortable={false} />
          <TextField label="Chef Hub Id" source="cookFullProfile.hubDetails.id" sortable={true} />
          <TextField label="Chef Hub Name" source="cookFullProfile.hubDetails.name" sortable={false} />
          <TextField label="Cook Category" source="cookFullProfile.cookCategory" sortable={false} />
          <TextField label="Preferred City" source="cookFullProfile.preferredCity" sortable={false} />,
          {!isCustomSelectOpen && [
            <TextField
              key={"7"}
              source="cookFullProfile.aadharNumber"
              label="Aadhar"
              sortable={false}
            />,
            <TextField key={"8"} label="Mode of Travel" source="cookFullProfile.modeOfTravel" sortable={false} />,
            <TextField key={"9"} label="Religion" source="cookFullProfile.religion" sortable={false} />,
          ]}

          <FunctionField
            label="Rating"
            render={(record: RaRecord) => (
              <CooksProfileLink href={record?.slug} />
            )}
          />
          <TextField source="cookFullProfile.onboardingStatus" label="Cook Onboarding Status" sortable={false} />
          <TextField source="cookFullProfile.onboardingSubStatus" label="Cook Onboarding Sub Status" sortable={false} />
          <CustomRefrenceField reference="AdminUsers" source="owner" label="Owner" />
          <CustomRefrenceField reference="Hubs" label="ChefHub" source="chefHub" />,
          <TextField source="cookFullProfile.verificationStatus" label="Verification Status" />
          <FunctionField
            label="Date of Birth"
            render={(record: any) =>
              record?.cookFullProfile?.dateOfBirth
                ? formatDate(record.cookFullProfile.dateOfBirth)
                : "-"
            }
          />
          {!isCustomSelectOpen && [
            <FunctionField
              key={"1"}
              label="Cooking Since"
              sortable={false}
              render={(record: any) =>
                record?.cookFullProfile?.cookingSince
                  ? formatDate(record.cookFullProfile.cookingSince)
                  : "-"
              }
            />,
            <TextField key={"2"} label="Work Status" source="cookFullProfile.workStatus" sortable={false} />,
            <TextField key={"3"} label="Work Status Reasoning" source="cookFullProfile.cookWorkStatusReasoning" sortable={false} />,
          ]}
          {/*Fields which will be not shown when custom popup is open goes here*/}
        </DatagridConfigurable>
        </StyledDatagridWrapper>
        <AdvancedCookFilterDialog setOpenAdvancedFilter={setOpenAdvancedFilter} openAdvancedFilter={openAdvancedFilter} filter={filter} setFilter={setFilter}/>
        </>
      </List>
    </>
  );
};

export default Cooks;
